(() => {
const fallback={"error_length":"Introduce una longitud de 1 a 400 cm, con un decimal como máximo (por ejemplo, 120,5).","error_options":"Selecciona las cuatro conexiones del cable.","error_config":"No podemos calcular esta configuración. Contacta con nosotros."};
const calculate=(config,input)=>{
 const tr=key=>config.i18n?.[key]||fallback[key];
 const raw=String(input.length??'').trim();
 const n=Number(raw.replace(',','.'));
 if(!/^[0-9]+(?:[.,][0-9])?$/.test(raw)||!Number.isFinite(n)||n<1||n>400)throw new Error(tr('error_length'));
 const band=config.bands.findIndex(b=>n<=b.max);
 const ts=[input.threadA,input.threadB].map(Number),ss=[input.squareA,input.squareB].map(Number);
 if(ts.some(x=>!Number.isInteger(x)||x<0||x>=config.threads.length)||ss.some(x=>!Number.isInteger(x)||x<0||x>=config.squares.length))throw new Error(tr('error_options'));
 const threads=ts.map(x=>x===5?1300:100),squares=ss.map(x=>x===2?200:100);
 const sku='CM-'+(band+1)+'-'+ts.filter(x=>x===5).length+'-'+ss.filter(x=>x===2).length;
 const variant=config.variants.find(v=>v.sku===sku);
 const total=config.bands[band].price+threads[0]+threads[1]+squares[0]+squares[1];
 if(!variant||variant.price!==total)throw new Error(tr('error_config'));
 return {length:n,band,ts,ss,threads,squares,total,variant};
};
globalThis.CableCalculator={calculate};
if(typeof document==='undefined')return;
document.querySelectorAll('[data-cable-configurator]').forEach(root=>{
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const guide=root.querySelector('.cm-guide');
 let guideTrigger=null;
 root.querySelectorAll('[data-guide-open]').forEach(button=>button.addEventListener('click',()=>{
  guideTrigger=button;guide.showModal();
  const section=guide.querySelector('[data-guide-section="'+button.dataset.guideOpen+'"]');
  if(section){section.scrollIntoView({block:'start'});section.focus({preventScroll:true});}
 }));
 guide.querySelector('.cm-guide-close').addEventListener('click',()=>guide.close());
 guide.addEventListener('click',event=>{if(event.target===guide){const r=guide.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)guide.close();}});
 guide.addEventListener('close',()=>guideTrigger?.focus());
 const cfg=JSON.parse(root.querySelector('[data-cable-config]').textContent);
 cfg.i18n=JSON.parse(root.querySelector('[data-cable-i18n]').textContent);
 const uiLocale=root.dataset.locale||'es',t=key=>cfg.i18n[key];
 const squareLabel=i=>new Intl.NumberFormat(uiLocale,{maximumFractionDigits:1}).format(Number(cfg.squares[i].replace('mm','').replace(',','.')))+' mm';
 const form=root.querySelector('form'),result=root.querySelector('.cm-result'),error=root.querySelector('.cm-error'),add=root.querySelector('.cm-add'),message=root.querySelector('.cm-cart-message');
 const base=window.Shopify?.routes?.root||'/';
 let state=null,live=null,currency='EUR';
 const money=c=>new Intl.NumberFormat(uiLocale,{style:'currency',currency}).format(c/100);
 for(const name of ['threadA','threadB','squareA','squareB']){
  const values=name.startsWith('thread')?cfg.threads:cfg.squares;
  values.forEach((s,i)=>{const o=document.createElement('option');o.value=String(i);o.textContent=name.startsWith('square')?squareLabel(i):s;form.elements[name].append(o);});
 }
 const ready=cfg.preview?Promise.resolve():fetch(base+'products/'+encodeURIComponent(cfg.productHandle)+'.js',{headers:{Accept:'application/json'}}).then(async r=>{if(!r.ok)return;const p=await r.json();live=p.variants;currency=window.Shopify?.currency?.active||cfg.currency||'EUR';}).catch(()=>{});
 form.addEventListener('input',()=>{state=null;result.hidden=true;error.hidden=true;});
 form.addEventListener('submit',async event=>{
  event.preventDefault();error.hidden=true;
  try{
   const input=Object.fromEntries(new FormData(form));
   if(['threadA','threadB','squareA','squareB'].some(k=>input[k]===''))throw new Error(t('error_select'));
   const next=calculate(cfg,input);await ready;state=next;
   const lv=live?.find(v=>String(v.id)===String(next.variant.id));const total=lv?lv.price:next.total;
   const rate=total/next.total;
   const prices=[next.threads[0],next.squares[0],next.threads[1],next.squares[1]].map(p=>Math.round(p*rate));
   const basePrice=total-prices.reduce((a,b)=>a+b,0);
   const rows=[
    [t('sheath')+' · '+next.length.toLocaleString(uiLocale,{maximumFractionDigits:1})+' cm',basePrice],
    [t('thread_a')+' · '+cfg.threads[next.ts[0]],prices[0]],
    [t('square_a')+' · '+squareLabel(next.ss[0]),prices[1]],
    [t('thread_b')+' · '+cfg.threads[next.ts[1]],prices[2]],
    [t('square_b')+' · '+squareLabel(next.ss[1]),prices[3]]
   ];
   const dl=root.querySelector('[data-breakdown]');dl.replaceChildren();
   rows.forEach(([label,price])=>{const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=money(price);row.append(dt,dd);dl.append(row);});
   for(const [k,labelText]of Object.entries({a:t('thread')+' '+cfg.threads[next.ts[0]],b:t('thread')+' '+cfg.threads[next.ts[1]],sa:t('square_side')+' '+squareLabel(next.ss[0]),sb:t('square_side')+' '+squareLabel(next.ss[1]),length:t('sheath')+': '+next.length.toLocaleString(uiLocale,{maximumFractionDigits:1})+' cm'}))root.querySelector('[data-svg="'+k+'"]').textContent=labelText;
   for(const [end,index] of [['a',0],['b',1]]){
    const nut=root.querySelector('[data-terminal-nut="'+end+'"]');
    const shapes=[
     {w:58,h:45,stem:27,pattern:'knurl',step:false},
     {w:61,h:49,stem:31,pattern:'ridges',step:false},
     {w:68,h:52,stem:31,pattern:'knurl',step:false},
     {w:65,h:55,stem:30,pattern:'knurl',step:false},
     {w:66,h:58,stem:26,pattern:'knurl',step:true},
     {w:72,h:64,stem:31,pattern:'ridges',step:true},
     {w:70,h:60,stem:29,pattern:'ridges',step:true},
     {w:78,h:68,stem:32,pattern:'knurl',step:true}
    ];
    const shape=shapes[next.ts[index]],x=170,y=142-shape.h/2,right=x+shape.w;
    const stemStart=shape.step?146:112;
    nut.removeAttribute('transform');
    nut.innerHTML='<rect x="112" y="'+(142-shape.stem/2)+'" width="146" height="'+shape.stem+'" rx="3" fill="#cbd5db" stroke="#7d8d97"/>'
     +(shape.step?'<rect x="146" y="'+(142-shape.stem/2-3)+'" width="24" height="'+(shape.stem+6)+'" rx="3" fill="#cbd5db" stroke="#7d8d97"/>':'')
     +'<rect x="'+x+'" y="'+y+'" width="'+shape.w+'" height="'+shape.h+'" rx="4" fill="#afbdc6" stroke="#7d8d97" stroke-width="1.2"/>'
     +'<rect x="'+(x+5)+'" y="'+(y+2)+'" width="'+(shape.w-10)+'" height="'+(shape.h-4)+'" rx="2" fill="url(#cm-'+shape.pattern+')" opacity=".65"/>'
     +'<path d="M120 '+(144-shape.stem/2)+'v'+(shape.stem-4)+'" stroke="#8e9ba3" opacity="0"/>';
    const thickness=[8,10.5,13.5][next.ss[index]],depth=thickness*.45,top=142-thickness/2,bottom=142+thickness/2,tip=root.querySelector('[data-square-tip="'+end+'"]');
    tip.querySelector('[data-square-face]').setAttribute('points','62,'+top+' 124,'+top+' 124,'+bottom+' 62,'+bottom);
    tip.querySelector('[data-square-top]').setAttribute('points','62,'+top+' '+(62+depth)+','+(top-depth)+' '+(124+depth)+','+(top-depth)+' 124,'+top);
    tip.querySelector('[data-square-cap]').setAttribute('points','62,'+top+' '+(62+depth)+','+(top-depth)+' '+(62+depth)+','+(bottom-depth)+' 62,'+bottom);
    const section=root.querySelector('[data-square-section="'+end+'"]'),size=[13,17,21][next.ss[index]];
    section.setAttribute('width',String(size));section.setAttribute('height',String(size));
    section.setAttribute('y',String(229-size/2));if(end==='b')section.setAttribute('x',String(912-size));
   }
   root.querySelector('[data-total]').textContent=money(total);
   root.querySelector('#cm-svg-desc').textContent=rows.map(x=>x[0]).join('. ');
   add.disabled=!lv?.available||!!cfg.preview;
   add.textContent=lv?.available&&!cfg.preview?t('add'):t('unavailable');
   message.textContent='';
   result.hidden=false;
   result.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  }catch(e){error.textContent=e.message;error.hidden=false;error.focus();}
 });
 add.addEventListener('click',async()=>{
  if(!state||!live)return;add.disabled=true;message.textContent='';
  const x=state,properties={
   [t('sheath')]:x.length.toLocaleString(uiLocale,{maximumFractionDigits:1})+' cm',
   [t('thread_a')]:cfg.threads[x.ts[0]],
   [t('square_a')]:squareLabel(x.ss[0]),
   [t('thread_b')]:cfg.threads[x.ts[1]],
   [t('square_b')]:squareLabel(x.ss[1]),
   '_Configurador':'cables-v1'
  };
  try{
   const r=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(x.variant.id),quantity:1,properties}]})});
   if(!r.ok)throw new Error(t('error_cart'));
   window.location.assign(base+'cart');
  }catch(e){message.textContent=e.message;add.disabled=false;}
 });
});
})();